import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, CircularProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import LoadingComponent from '../../../_commons/LoadingComponent';
import api from '@utils/axiosInstance';

const DeleteModal = ({ open, setOpen, uuid }) => {
    const { t } = useTranslation();

    const organizationData = useSelector(state => state.organization.organizationData);
    const userToken = useSelector(state => state.organization.userToken);

    const [result, setResult] = useState('');

    const handleClose = () => {
        setOpen(false);
    };

    const handleDelete = () => {
        setResult('ready');

        api({
            method: 'post',
            url: '/batchRemover/delWork',
            data: {
                tk: userToken,
                ogc: organizationData.organization_code,
                type: "vod",
                data: {
                    uuid: uuid
                }
            }
        })
            .then((response) => {
                if (response.data.code === 100) {
                    console.log('aa', response.data);
                    setResult('success');
                    setOpen(false);
                }
            })
            .catch((error) => {
                setResult('error');
            });
    };

    return (
        <div>
            <Dialog
                fullWidth
                maxWidth="sm"
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                disablePortal
            >
                <DialogTitle id="alert-dialog-title">
                    <Typography variant="h6">{t('vod.bulk_deleter.confirm_delete')}</Typography>
                </DialogTitle>
                <DialogContent className="bulkdeleter-delete-modal-content">
                    {
                        result === 'ready' ?
                            <DialogContentText id="alert-dialog-description" className="bulkdeleter-delete-modal-loading">
                                <CircularProgress size={20} className="bulkdeleter-delete-modal-spinner" />
                                <Typography variant="body1">{t('vod.bulk_deleter.deleting')}</Typography>
                            </DialogContentText>
                            :
                            result === 'success' ?
                                <DialogContentText id="alert-dialog-description">
                                    <Typography variant="body1">{t('vod.bulk_deleter.delete_success')}</Typography>
                                </DialogContentText>
                                :
                                result === 'error' ?
                                    <DialogContentText id="alert-dialog-description">
                                        <Typography variant="body1">{t('common.error_occurred')}</Typography>
                                    </DialogContentText>
                                    :
                                    <DialogContentText id="alert-dialog-description">
                                        <Typography variant="body1">{t('vod.bulk_deleter.confirm_action')}</Typography>
                                    </DialogContentText>
                    }
                </DialogContent>
                <DialogActions className="bulkdeleter-delete-modal-actions">
                    <Button onClick={handleClose} color="primary">
                        {t('vod.bulk_deleter.cancel')}
                    </Button>
                    <Button onClick={handleDelete} color="error" autoFocus>
                        {t('vod.bulk_deleter.delete')}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default DeleteModal;